import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const AboutSection = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-16 md:py-24 bg-slate-50"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* About Content */}
          <div className="space-y-8 animate-fade-in-up">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                About Cozy Nests
              </h2>
              <div className="section-divider mb-6"></div>
            </div>

            <div className="space-y-4 text-slate-600 leading-relaxed">
              <p>
                <span className="font-semibold text-slate-900">Cozy Nests</span> is a locally owned and operated pet grooming business serving the New York City community. We're passionate about pets and dedicated to providing top-quality grooming services in a safe, comfortable environment.
              </p>
              <p>
                Our team of experienced groomers treats every pet like family. We understand that grooming can be stressful for some animals, which is why we focus on gentle handling techniques and creating a calming atmosphere for all our furry clients.
              </p>
              <p>
                Whether your dog needs a full makeover or your cat requires a gentle brush-out, we have the skills and patience to make it a positive experience for your pet.
              </p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="animate-fade-in-up animation-delay-200">
            <div className="bg-white rounded-3xl p-8 shadow-lg border border-slate-100">
              <h3 className="font-heading text-2xl font-bold text-slate-900 mb-6">
                Contact Information
              </h3>

              <div className="space-y-6">
                {/* Business Name */}
                <div
                  data-testid="about-business-name"
                  className="flex items-start gap-4"
                >
                  <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center shrink-0">
                    <span className="text-sky-600 font-bold text-lg">C</span>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Business Name</p>
                    <p className="text-slate-600">Cozy Nests</p>
                  </div>
                </div>

                {/* Address */}
                <div
                  data-testid="about-address"
                  className="flex items-start gap-4"
                >
                  <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center shrink-0">
                    <MapPin className="w-5 h-5 text-sky-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Address</p>
                    <p className="text-slate-600">20 E 22nd St #4699<br />New York, NY 10165, United States</p>
                  </div>
                </div>

                {/* Phone */}
                <div
                  data-testid="about-phone"
                  className="flex items-start gap-4"
                >
                  <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center shrink-0">
                    <Phone className="w-5 h-5 text-sky-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Phone</p>
                    <a
                      href="tel:+18888801344"
                      className="text-sky-600 hover:text-sky-700 transition-colors"
                    >
                      +1-888-8801-344
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div
                  data-testid="about-email"
                  className="flex items-start gap-4"
                >
                  <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center shrink-0">
                    <Mail className="w-5 h-5 text-sky-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Email</p>
                    <a
                      href="mailto:bookings@cozynests.store"
                      className="text-sky-600 hover:text-sky-700 transition-colors"
                    >
                      bookings@cozynests.store
                    </a>
                  </div>
                </div>

                {/* Hours */}
                <div
                  data-testid="about-hours"
                  className="flex items-start gap-4"
                >
                  <div className="w-12 h-12 bg-sky-100 rounded-xl flex items-center justify-center shrink-0">
                    <Clock className="w-5 h-5 text-sky-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">Business Hours</p>
                    <p className="text-slate-600">
                      Monday - Saturday: 9:00 AM - 6:00 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
